// extracted by mini-css-extract-plugin
module.exports = {"title":"roomstay-blog-case-studies_title__I5XJc","root":"roomstay-blog-case-studies_root__tWnwt"};